// inv/src/components/ui/shadowbox.jsx
import { cn } from "../../lib/utils";

const ShadowBox = ({
  title,
  children,
  subtitle,
  footer,
  className = "",
  ...props
}) => {
  return (
    <div
      className={cn(
        "flex h-full min-w-0 max-w-full flex-col rounded-xl border border-stone-300 bg-white shadow-md",
        className
      )}
      {...props}
    >
      <div className="flex h-full w-full flex-col space-y-2 p-4">
        {title && (
          <div className="text-2xl font-bold tracking-tight text-muted-foreground">
            {title}
          </div>
        )}

        {children && <div className="flex-1 text-gray-900">{children}</div>}

        {subtitle && <p className="text-xs text-muted-foreground">{subtitle}</p>}
        {footer && <div className="pt-2 text-sm text-muted-foreground">{footer}</div>}
      </div>
    </div>
  );
};

ShadowBox.displayName = "ShadowBox";

export { ShadowBox };
